'use client';
import { rem } from '@s7/styles';

const calculatePaddings = (profile)=>{
    if (!profile) {
        return '3.5s 4s';
    }
    if (profile.firstName) {
        return '1.5s 3s';
    }
    if (profile.avatarUrl) {
        return '1.5s';
    }
    return '3.5s';
};
const profileStyles = (profile)=>(theme)=>({
            padding: theme.fn.space(calculatePaddings(profile)),
            borderRadius: theme.fn.borderRadius('1.5r'),
            height: rem(48)
        });

export { profileStyles };
//# sourceMappingURL=HeaderProfile.styles.js.map
